import type { Event } from '@gb/common';

export function getSortedBartenders(
  bartenders: Event['bartenders'],
): [string, string][] {
  const entries = Object.entries(bartenders || {});

  return entries.sort((a, b) => a[1].localeCompare(b[1]));
}
